
import { Component, Vue, Prop } from 'vue-property-decorator'
import { handleFill, moneyFormat } from '@/utils/util';
// import LineChart from "@/components/LineChart/index.vue";
import StackedAreaChart from "@/components/StackedAreaChart/index.vue";

@Component({
  components: { StackedAreaChart},
})
export class LongTimePeriod extends Vue {
  @Prop({ default: () => { } }) LongTimeData: any
  handleFill = handleFill
  moneyFormat = moneyFormat
}
export default LongTimePeriod
